(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/helpers/soccer-helper.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/helpers/soccer-helper.js'); 
(function() {
  'use strict';

  var isServerSide = typeof exports === 'object';
  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    function buildTeamLineup(team, rev) {
      var ret = '';
      var rowLength = team.length;

      if (rev) {
        var revTeam = [];
        _.each(team, function(row) {
          var line = [];
          _.each(row, function(player) {
            line.unshift(player);
          });
          revTeam.unshift(line);
        });
        team = revTeam;
      }

      _.each(team, function(row, i) {
        if (row.length > 4) {
          var odd = [],
            even = [];
          _.each(row, function(player, i) {
            if (i % 2) {
              even.push(player);
            } else {
              odd.push(player);
            }
          });
          if (rev) {
            team.splice(i, 1, odd, even);
          } else {
            team.splice(i, 1, even, odd);
          }

          rowLength++;
        }
      });

      _.each(team, function(row) {
        var playerLength = row.length;

        ret +=
          '<div class="lineup-row clearfix" style="height:' +
          100 / rowLength +
          '%;">';
        _.each(row, function(player) {
          ret +=
            '<div class="player-position" style="width:' +
            100 / playerLength +
            '%;">';
          ret +=
            '<span class="shirt-number-wrapper"><span class="shirt-number">' +
            (player.shirtNumber || '') +
            '</span></span>';
          ret += '<span class="player-name">' + player.shortName + '</span>';
          ret += '</div>';
        });
        ret += '</div>';
      });
      return ret;
    }

    hbs.registerHelper('renderField', function(away, home) {
      var ret = '<div class="play-field">';

      ret += '<div class="away-team-lineup">';
      ret += buildTeamLineup(home);
      ret += '</div>';

      ret += '<div class="home-team-lineup">';
      ret += buildTeamLineup(away, true);
      ret += '</div>';

      ret += '</div>';
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('filterStatistics', function(data, options) {
      var result = false;
      if (data.name !== 'Bollinnehav' && data.name !== 'Skott utanför mål') {
        result = true;
      }

      if (data.home === '') {
        data.home = '0';
      }

      if (data.away === '') {
        data.away = '0';
      }

      if (result) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('ifShowOdds', function(match, options) {
      var showOdds =
        match.isShowOdds &&
        !svs.themes.sport_soccer.isFullTimeOrPassed(match.status);

      if (showOdds) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('showRedCards', function(noOfRedCards, isOddsetWidget) {
      var accum = '';
      for (var i = 0; i < noOfRedCards; ++i) {
        if (!isOddsetWidget) {
          accum += '<i class="red-card icon-default icon-card match-card"></i>';
        } else {
          accum += '<i class="icon-default icon-card matchname-red-card"></i>';
        }
      }
      return accum;
    });

    hbs.registerHelper('ifShowPenaltyResult', function(events, options) {
      var penalties = [];

      if (events && events.league.sport.type === 1) {
        if (events.result) {
          penalties = _.where(events.result, { type: 4 });

          if (penalties.length) {
            return options.fn(this);
          }
          return options.inverse(this);
        }
      }
    });

    hbs.registerHelper('showPenaltyResult', function(events, pram) {
      var penalties = [];

      if (events && events.league.sport.type === 1) {
        if (events.result) {
          penalties = _.findWhere(events.result, { type: 4 });
          if (pram === 'homePeriod') {
            return penalties.homePeriod;
          } else if (pram === 'awayPeriod') {
            return penalties.awayPeriod;
          }
        }
      }
    });
  }
})();

 })(window);